// Courtesy of https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome/13348618#13348618

const IPHONE = 'iPhone';
const IPAD = 'iPad';

function browserCheck() {
	// This util will need to be updated as browser technology changes, and more conditions added as browsers support PWAs
	const ua = window.navigator.userAgent;
	const isIphone = !!ua.match(/iphone/i);
	const isIpad = !!ua.match(/ipad/i);
	const iOS = isIpad || isIphone;
	const webkit = !!ua.match(/webkit/i);
	const iOSSafari = iOS && webkit && !ua.match(/crios/i);

	if (iOSSafari && isIpad) {
		return IPAD;
	} else if (iOSSafari && isIphone) {
		return IPHONE;
	} else return null;
}

function isIPad() {
	return browserCheck() === IPAD;
}

function isIPhone() {
	return browserCheck() === IPHONE;
}

export {isIPad, isIPhone};

export default browserCheck;
